module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/da344f9eddd688edb8b870fa3167d691.svg";